/*
 * View for a single substitution category
 */

define([
  "marionette",
  "./template/categoryNameLocalizedTemplate.html",
  "./template/categoryNameEntriesLocalizedTemplate.html",
], function (Marionette, CategoryNameLocalizedTemplate, CategoryNameEntriesLocalizedTemplate) {
  const CategoryNamesLocalizedView = {};

  CategoryNamesLocalizedView.categoryNameLocalizedView = Marionette.ItemView.extend({
    template: CategoryNameLocalizedTemplate,
    tagName: "tr",
    textboxes: function () {
      return {
        "#categoryLocalizedName": {
          enableSelector: "#categoryLocalizedName",
          modelAttribute: "name",
          textArea: false,
          doNotModifyPlaceholder: true,
          placeholder: this.model.collection.categoryName,
        },
      };
    },
  });

  CategoryNamesLocalizedView.categoryNamesLocalizedView = Marionette.CompositeView.extend({
    template: CategoryNameEntriesLocalizedTemplate,
    itemView: CategoryNamesLocalizedView.categoryNameLocalizedView,
    itemViewContainer: "tbody",
  });

  return CategoryNamesLocalizedView;
});
